// Compiled at 2026-09-18T12:45:23.821Z
import { unwrapReadonly, assignCommonProperties, coerceDataType, createReadonlyProxy } from "@lg/shared/for-apps";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Orders, Orders as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ChangeDetectionStrategy, inject, input, signal, computed, effect, linkedSignal, viewChild } from "@angular/core";
import { NavigationSkipped } from "@angular/router";
import { AppState, app } from "../../ClientDataStore/$state";
import { AbstractScreen } from "@lg/ng-shared";
import type { ValidationRules } from "@lg/shared";
import { BoInfoSymbol } from "@lg/shared/for-apps";
import { ProxyTargetSymbol } from "@lg/shared/for-apps";
import { Semaphore } from "@lg/shared/for-apps";
import { memoize } from "@lg/shared/for-apps";
import { NgSharedModule } from "@lg/ng-shared";
import { combineLatest, filter } from "rxjs";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ProcessTaskComponent } from "../../components/process-task.component";
import { proxySignal, ProxySignal } from "../../signals.js";
import { MainLayout as Orders__MainLayout } from "../Orders/MainLayout.js";
import { CustomerRequestInclude as Orders__CustomerRequestInclude } from "../Orders/CustomerRequestInclude.js";
import { MatButtonModule } from "@angular/material/button";

interface Properties {
    request: This.CustomerRequest;
}

interface State {
    app: AppState;
    screen: Properties;
}

@Component({
    selector: 'Orders-CustomerRequestProcess',
    templateUrl: './CustomerRequestProcess.html',
    styleUrls: ['./CustomerRequestProcess.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgSharedModule,
        Orders__MainLayout,
        Orders__CustomerRequestInclude,
        MatButtonModule
    ],
})
export class CustomerRequestProcess extends AbstractScreen implements OnInit, AfterViewInit {
    static readonly $canBeMainScreen = true;
    static readonly $canBeDialogScreen = true;
    readonly $qualifiedScreenName = 'Orders.CustomerRequestProcess';
    $isDialog = false;
    $Modules = $Modules;
    Orders = Orders;
    System = System;
    Common = Common;
    Sys = Sys;
    This = This;
    app = app;
    $scope = {};
    $pathSegments: string[] = [];
    $processTaskComponent = inject(ProcessTaskComponent, { optional: true });
    @Output()
    submit = new EventEmitter<This.CustomerRequest>();
    @Output()
    close = new EventEmitter<{
        delete: boolean,
    }>();
    output = {
        submit: async (data: This.CustomerRequest, followNextUserTask = true) => {
            data = (data as any)?.$clone ? (data as any).$clone() : data
            let result: any
            result = await (followNextUserTask ? Sys.Process.driveProcessAndFollowNextUserTask : Sys.Process.driveProcess)('submit', data)
            this.submit.emit(data)
            if (this.dialogData?.closeOnOutput === 'submit') { this.dialogRef?.close(data) }
            return result
        },
        close: async (data: {
            delete: boolean,
        }, followNextUserTask = true) => {
            data = (data as any)?.$clone ? (data as any).$clone() : data
            let result: any
            result = await (followNextUserTask ? Sys.Process.driveProcessAndFollowNextUserTask : Sys.Process.driveProcess)('close', data)
            this.close.emit(data)
            if (this.dialogData?.closeOnOutput === 'close') { this.dialogRef?.close(data) }
            return result
        },
    };
    $validators: Record<number, ValidationRules> = {

    };
    input_request = input(undefined, { alias: 'request' });
    var_request = proxySignal<This.CustomerRequest>(undefined as any);
    readonly screen =
        ((component: typeof this) => {
            return {
                get request() { return component.var_request() },
                set request(value: This.CustomerRequest) { component.var_request.set(value) }
            }
        })(this)
        ;

    get $inputs() {
        return {
            request: this.screen.request
        }
    }

    async ngOnInit(): Promise<void> {
        super.ngOnInit()
        if (!this.$processTaskComponent) {
            this.processService.tokenId.set(undefined)
        }


    }

    async ngAfterViewInit(): Promise<void> {
    }

    constructor() {

        super()

        effect(() => {
            if (!this.authService.isInitialized()) return
            const isVariablesInitialized = this.$isVariablesInitialized()
            const { screen, app } = this

            const new_request = this.dialogData?.data?.request ?? this.input_request() ?? (undefined)
            if (new_request !== undefined) this.screen.request = new_request

            this.$isVariablesInitialized.set(true)
        })

        effect(() => {
            if (!this.$isVariablesInitialized()) return
            if (!this.$isOnInitCalled) {
                this.$isOnInitCalled = true
                setTimeout(async () => {
                    await this.action_onInit()
                    this.$isFullyInitialized.set(true)
                })
            }
        })



    }

    async handler_ButtonBlock_25_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { form, $disabled }: { form: Sys.Types.Form, $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    output.submit(screen.request)
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_ButtonBlock_30_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { form, $disabled }: { form: Sys.Types.Form, $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    if (confirm('Are you sure you want to manually close this request?')) {
                        output.close({
                            delete: false,
                        })
                    }
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async handler_ButtonBlock_31_click_$adhoc_0($event: any, $scope: any): Promise<void> {
        let { form, $disabled }: { form: Sys.Types.Form, $disabled: any } = $scope ?? {}

        {

            const { app, screen, output } = this
            try {
                const θnormalReturn = Symbol()
                const ret = await (async () => {
                    if (confirm('Are you sure you want to delete this request?')) {
                        output.close({
                            delete: true,
                        })
                    }
                    return θnormalReturn
                })()
                if (θnormalReturn !== ret) return
            } catch (err: any) {
                Sys.App.showError(err)
            }
            $event?.preventDefault?.()
            $event?.stopPropagation?.()
        }
    }

    async action_onInit($event?: any) {
        const { app, screen, output } = this
        {

        }
    }
}
